import { useState, useEffect } from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { getAdminEmployers, createEmployer, updateEmployer, deleteEmployer } from '../../services/api';
import toast from 'react-hot-toast';

const emptyEmployer = { name: '', logo_url: '', website: '', location: '', description: '', industry: '', is_active: 1 };

export default function AdminEmployers() {
  const [emps, setEmps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyEmployer);

  const load = () => {
    getAdminEmployers().then(res => { setEmps(res.data); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(load, []);

  const openCreate = () => { setEditing(null); setForm(emptyEmployer); setShowModal(true); };
  const openEdit = (emp) => { setEditing(emp.id); setForm(emp); setShowModal(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) { await updateEmployer(editing, form); toast.success('Employer updated'); }
      else { await createEmployer(form); toast.success('Employer created'); }
      setShowModal(false);
      load();
    } catch { toast.error('Failed to save'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this employer?')) return;
    try { await deleteEmployer(id); toast.success('Deleted'); load(); }
    catch { toast.error('Failed to delete'); }
  };

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="admin-table-wrap">
        <div className="admin-table-header">
          <h2>Manage Employers ({emps.length})</h2>
          <button className="btn-create" onClick={openCreate}><Plus size={18} /> Add Employer</button>
        </div>
        {emps.length === 0 ? (
          <div className="empty-state"><h3>No employers</h3></div>
        ) : (
          <table className="admin-table">
            <thead><tr><th>Name</th><th>Industry</th><th>Location</th><th>Website</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {emps.map(e => (
                <tr key={e.id}>
                  <td style={{ fontWeight: 600 }}>{e.name}</td>
                  <td>{e.industry || '-'}</td>
                  <td>{e.location || '-'}</td>
                  <td>{e.website ? <a href={e.website} target="_blank" rel="noreferrer" style={{ color: '#2563eb' }}>Visit</a> : '-'}</td>
                  <td><span className={`status-badge ${e.is_active == 1 ? 'status-published' : 'status-draft'}`}>{e.is_active == 1 ? 'active' : 'inactive'}</span></td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => openEdit(e)}><Pencil size={14} /> Edit</button>
                      <button className="btn-delete" onClick={() => handleDelete(e.id)}><Trash2 size={14} /> Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editing ? 'Edit Employer' : 'Add Employer'}</h2>
            <form onSubmit={handleSave}>
              <div className="form-row">
                <div className="form-group">
                  <label>Company Name *</label>
                  <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Industry</label>
                  <input type="text" placeholder="e.g. IT / Software" value={form.industry} onChange={e => setForm({...form, industry: e.target.value})} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Location</label>
                  <input type="text" value={form.location} onChange={e => setForm({...form, location: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Website</label>
                  <input type="text" placeholder="https://..." value={form.website} onChange={e => setForm({...form, website: e.target.value})} />
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} style={{ minHeight: 80 }} />
              </div>
              <div className="form-group">
                <label>Status</label>
                <select value={form.is_active} onChange={e => setForm({...form, is_active: parseInt(e.target.value)})}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="btn-save">{editing ? 'Update' : 'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
